// extracted by mini-css-extract-plugin
export default {"root":"Timeline_root__wE4yr","marker":"Timeline_marker__aJGw0","item":"Timeline_item__a72LH","item--line-variant-dashed":"Timeline_item--line-variant-dashed__YFu2g"};